<template>
  <div class="container">
    <div class="benefit_header" >
      <div class="header_title">
        <p>DENTRION's</p>
        <p>Exclusive Free Trial</p>
      </div>
      <div class="sub_text">
        <p>Elevate Your Cases Today</p>
      </div>
    </div>

    <div class="benefit_container">
      <div class="ticket_wrapper">
        <!-- Background Images -->
        <img src="../assets/image/ticket.png" alt="Ticket Background" class="ticket_bg" />
        <img src="../assets/image/dash.png" alt="Dashed Line" class="ticket_dash" />
        
        <!-- Text Content Overlay -->
        <div class="ticket_content">
          <div class="coupon_section section_top">
            <p class="benefit_label">Benefit 01</p>
            <p class="benefit_main">FREE</p>
            <p class="benefit_desc">1 Digital Case</p>
          </div>
          
          <div class="coupon_section section_bottom">
            <p class="benefit_label">Benefit 02</p>
            <p class="benefit_main">7-DAY</p>
            <p class="benefit_desc">Fast shipping / In-Lab Working time</p>
          </div>
        </div>
      </div>
    </div>

    <div class="benefit_footer">
      <div class="footer_title">Shipping via</div>
      <div class="delivery_logos">
        <img src="../assets/icon/delivery_01.png" alt="DHL" class="vendor_logo" style="width: 142px;" />
        <img src="../assets/icon/delivery_02.png" alt="FedEx" class="vendor_logo" style="width: 124px;" />
        <img src="../assets/icon/delivery_03.png" alt="UPS" class="vendor_logo" style="height: 65px; width: auto;" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
/* Container & Layout */
.container {
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  padding: 60px 0;
  box-sizing: border-box;
  font-family: 'Wanted Sans', sans-serif; /* Assuming font is available globally */
}

/* Header */
.benefit_header {
  text-align: left;
  padding: 0 30px;
}

.header_title p {
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
}

.sub_text p {
  font-size: 18px;
  font-weight: 400;
  color: #fff;
  margin-top: 10px;
}

/* Ticket Wrapper */
.benefit_container {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.ticket_wrapper {
  position: relative;
  max-width: 400px;
}

.ticket_bg {
  width: 100%;
  
  z-index: 1;
}

.ticket_dash {
  position: absolute;
  top: 48%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  z-index: 2;
  padding: 0 40px;   
  box-sizing: border-box;
}

.ticket_content {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 3;
  gap: 30px;
}

.coupon_section {
  display: flex;
  flex-direction: column;
  padding: 0 60px; 
}

/* Typography styles */
.benefit_label {
  font-size: 12px;
  color: #000;
  text-decoration: underline;
  text-underline-offset: 4px;
  font-weight: 600;
  margin-bottom: 8px;
}

.benefit_main {
  font-size: 40px;
  font-weight: 700;
  font-style: italic;
  color: #0B485B; 
  line-height: 1;
  margin-top: 16px;
}

.benefit_desc {  
  color: #0B485B;
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 128%;
  letter-spacing: -0.8px;
}

/* Footer & Logos */
.benefit_footer {
  margin-top: 60px;
  text-align: center;
}

.footer_title {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 30px;
}

.delivery_logos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
}

.vendor_logo {
  object-fit: contain;
}
</style>
